import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import StoreOptician from './StoreOptician/StoreOptician.js';

const StoreOpticians = (_param)=>{
    var { className , labels , opticians , fallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "opticians",
        "fallbackImage"
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-opticians', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React.createElement("div", {
        className: "store-opticians__items"
    }, opticians.map((optician)=>/*#__PURE__*/ React.createElement(StoreOptician, {
            key: optician.name,
            className: "store-opticians__optician",
            name: optician.name,
            details: optician.details,
            imageUrl: optician.imageUrl,
            fallbackImageUrl: fallbackImage
        })
    )));
};

export { StoreOpticians as default };
//# sourceMappingURL=StoreOpticians.js.map
